import React, {Component} from 'react';
import jcg from '../images/jcg.png' // relative path to image
import vch from '../images/vch.png'
import lma from '../images/lma.png'
import dpl from '../images/dpl.png'
import jfv from '../images/jfv.png'
import lsi from '../images/lsi.png'
import thh from '../images/thh.png'
import fci from '../images/fci.png'
import thv from '../images/thv.png'
import phl from '../images/phl.png'
import ryu from '../images/ryu.png'
import dba from '../images/dba.png'

import agiragri from '../images/agiragri.png'
import notaire from '../images/notaire.png'
import terresa from '../images/terresa.png'
import fpf from '../images/fpf-france.png'


export default class Team extends Component {

    render() {
        const imgPartnerStyle = {
            width: "10rem"
        };
        const imgStyle = {
            width: "7rem"
        };

        return (
            <div>
                <h2>Equipe opérationnelle</h2>
                <div className="row">
                    <div className="col-sm-8">
                        <ul className="list-unstyled" >
                            <li className="media">
                                <img className="mr-3" src={jcg} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Jean Christophe GUERARD</h5>
                                    22 ans d'expérience dans le financement des TPE, PME et la gestion de patrimoine de l'entrepreneur.
                                    <br />Management d'équipes pluridisciplinaires.
                                    <br />Master II Banque& Finance, agrément AMF CIP.</div>
                            </li>
                            <li className="media">
                                <img className="mr-4" src={fci} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Florent CIBERT</h5>
                                    Relations investisseurs.
                                    <br />Hôtelier Investisseur,
                                    <br />Ecole Hôtelière de Lausanne.
                                </div>
                            </li>
                            <li className="media my-4">
                                <img className="mr-3" src={vch} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Valérie CHEVALIER</h5>
                                    25 ans d'expérience dans le marketing et la communication de produits financiers en banque de détail, des sujets de transformation digitale et d'approche multicanale.
                                    <br />Master Finance Dauphine.
                                </div>
                            </li>
                            <li className="media mt-4">
                                <img className="mr-3" src={dpl} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Damien PAUL</h5>
                                    Ingénieur POLYTECH.
                                    <br />Architecte solutions & plateformes web, algorithmes multicritères et moteurs de recherche,
                                    <br />20 ans d'expérience.
                                </div>
                            </li>

                        </ul>

                    </div>
                    <div className="col-sm-4"></div>
                </div>

                <br />
                <h2>Comité des vins</h2>
                <div className="row">
                    <div className="col-sm-8">
                        <ul className="list-unstyled" >
                            <li className="media">
                                <img className="mr-3" src={jfv} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Jean-François VANDROUX, associé</h5>
                                    Fondateur et Dirigeant d’ANIMA VINUM.
                                    <br />L'un des principaux négociants des Hospices de Beaune.
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={thh} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Thomas HAVAS, Vice-président, associé fondateur</h5>
                                    Diplôme d’œnologie du Wine & Spirit Education Trust - Niveau 3
                                    <br />Diplôme d'HEC, expert en Communication
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={lma} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Laurent MARTY</h5>
                                    Œnologue cartographe Alphavini.com.
                                    <br />Diplôme d’œnologie  WSET 3
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={dba} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">David BAROCHE, associé fondateur</h5>
                                    Professionnel de la restauration parisienne gourmande.
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={lsi} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Loic SIRI, œnologue professionnel</h5>
                                    Conseil en communication et marketing auprès des domaines viticoles.
                                    <br />Ecole d’œnologie Bordeaux.
                                </div>
                            </li>

                        </ul>

                    </div>
                    <div className="col-sm-4"></div>
                </div>

                <br />
                <h2>Comité des investissements</h2>
                <div className="row">
                    <div className="col-sm-8">
                        <ul className="list-unstyled" >
                            <li className="media">
                                <img className="mr-3" src={jcg} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Jean Christophe GUERARD</h5>
                                    Président
                                </div>
                            </li>
                            <li className="media my-4">
                                <img className="mr-3" src={fci} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Florent CIBERT</h5>
                                    Relations investisseurs.
                                    <br />Hôtelier Investisseur,
                                    <br />Ecole Hôtelière de Lausanne.
                                </div>
                            </li>

                            <li className="media my-4">
                                <img className="mr-3" src={vch} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Valérie CHEVALIER</h5>
                                    Directrice Relations Investisseurs.
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={thv} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Thierry VAISSADE</h5>
                                    Directeur Clientèle Institutionnelle Bénélux chez HSBC global Asset management.
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={phl} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Philippe LOIZELET</h5>
                                    Conseil en gestion de patrimoine, spécialiste du monde viticole
                                    <br />Président ANCDGP (Association des Conseils Diplômé en Gestion de Patrimoine)
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={ryu} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Rodolphe YUNG</h5>
                                    propriétaire de 5 domaines dans la région de Bordeaux
                                    <br />Expert comptable
                                </div>
                            </li>

                        </ul>

                    </div>
                    <div className="col-sm-4"></div>
                </div>

                <br />
                <h2>Partenaires conseils</h2>
                <div className="row">
                    <div className="col-sm-8">
                        <ul className="list-unstyled" >
                            <li className="media">
                                <img className="mr-3" src={agiragri} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1">Réseaux d’experts comptables viticoles AGIRAGRI</h5>
                                    <a href="https://www.agiragri.com">www.agiragri.com</a>
                                </div>
                            </li>
                            <li className="media mr-4 mt-4">
                                <img className="mr-3" src={notaire} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1 mt-4">Maître André (Meursault), Maître Hoche (Villie Morgon)</h5>
                                    Spécialiste des questions viti-vinicoles et du bail cessible.
                                </div>
                            </li>

                            <li className="media mr-4">
                                <img className="mr-3" src={terresa} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1 mt-2">Maître Julien Forget</h5>
                                    Sspécialiste du droit rural et membre d’AGIRAGRI.
                                </div>
                            </li>

                            <li className="media mt-4">
                                <img className="mr-3" src={fpf} alt="Generic placeholder image" style={imgStyle}/>
                                <div className="media-body">
                                    <h5 className="mt-0 mb-1 mt-0">Financement Participatif France</h5>
                                    « Le plaidoyer agricole » travail de fond avec le législateur afin de faciliter le financement participatif du secteur agricole.
                                    <br />En 2018, nous avons sensibilisé les Ministères de l’Agriculture, de Bercy, du Numérique et la mission foncière à l’Assemblée Nationale
                                </div>
                            </li>

                        </ul>

                    </div>
                    <div className="col-sm-4"></div>
                </div>
            </div>
        );
    }
}
